import { RouteProp } from '@react-navigation/native';
import React, { useMemo } from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import CodeStatusFormFields, {
    getDefaultFromValue,
    formValueToUpsertProfileCodeStatusRequest,
} from '../../../../shared/Directives/CodeStatusFormFields';
import { Form } from '../../../../v2BaseComponents/Form';
import { useMedicalProfileDirectives } from '../../../../../hooks/api/useMedicalProfileDirectives';

export type EditCodeStatusScreenOwnProps = {};

export type EditCodeStatusScreenProps = EditCodeStatusScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'edit-code-status'>;
};

const EditCodeStatusScreen: React.FC<EditCodeStatusScreenProps> = (props) => {
    const goBack = useGoBack();
    const { isLoadingCodeStatus, codeStatus, updateCodeStatus, isUpdatingCodeStatus } = useMedicalProfileDirectives({
        medicalProfileId: props.route.params.profileId,
        onCodeStatusUpdateSuccess: goBack,
    });
    const initialValue = useMemo(() => getDefaultFromValue(codeStatus), [codeStatus]);
    const isLoading = isLoadingCodeStatus || isUpdatingCodeStatus;

    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <Form
                    fillContainer
                    actionContainerSubmit
                    initialValues={initialValue}
                    onSubmit={(values) => {
                        const upsertRequest = formValueToUpsertProfileCodeStatusRequest(values, codeStatus);
                        updateCodeStatus(upsertRequest);
                    }}
                    onCancel={goBack}
                >
                    {({ values, setFieldValue }) => (
                        <CodeStatusFormFields values={values} setFieldValue={setFieldValue} />
                    )}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditCodeStatusScreen);
